import { ChangeDetectorRef, Component } from '@angular/core';
import { Link } from '../../../../models/link';
import { ModalService } from '../../../../services/modal.service';
import { QuickLink } from '../../../../models/quick-link';
import { Subscription } from 'rxjs';
import { HomeworkLink } from '../../../../models/homework-link';
import { Modalable } from '../../../../models/modalable';
import { ApplicationStateService } from '../../../../services/application-state.service';
import { ModalableWhiteboardDrawing } from '../../../../models/modalable-whiteboard-drawing';
import { ModalableWhiteboardVideo } from '../../../../models/modalable-whiteboard-video';
import { ModalableYedo } from '../../../../models/modalable-yedo';
import { ModalableAccessCode } from '../../../../models/modalable-access-code';
import { Materials } from '../../../../models/materials';
import { AssignmentsLink } from '../../../../models/assignments-link';
import { HomeworkExercisePreviewModalable } from '../../../../models/homework-exercise-preview-modalable';
import { Video } from '../../../../models/video';
import { OfflineModeService } from '../../../../services/offline-mode.service';
import { HomeworkModalComponent } from '../../../sidebar/tasks/homework/homework-modal/homework-modal.component';
import {
    HomeworkExercisePreviewModalComponent
} from './homework-exercise-preview-modal/homework-exercise-preview-modal.component';
import {
    AssignmentsLinkModalComponent
} from '../../page/book-feature/page-quick-link/assignments-link-modal/assignments-link-modal.component';
import {
    WhiteboardVideoModalComponent
} from '../../page/book-feature/whiteboard-drawing/whiteboard-video-modal/whiteboard-video-modal.component';
import { AccessCodeModalComponent } from './access-code-modal/access-code-modal.component';
import { LinkModalComponent } from '../../page/book-feature/page-link/link-modal/link-modal.component';
import { DigiTrainerModalComponent } from './digi-trainer-modal/digi-trainer-modal.component';
import { RedirectModalComponent } from './redirect-modal/redirect-modal.component';
import {
    PlatformLinkCopiedConfirmationModalComponent
} from './platform-link-copied-confirmation-modal/platform-link-copied-confirmation-modal.component';
import {
    QuickLinkModalComponent
} from '../../page/book-feature/page-quick-link/quick-link-modal/quick-link-modal.component';
import { YedoModalComponent } from './yedo-modal/yedo-modal.component';
import { OfflineVersionModalComponent } from './offline-version-modal/offline-version-modal.component';
import { ClassSharingModalComponent } from './class-sharing-modal/class-sharing-modal.component';
import { BuyBookModalComponent } from './buy-book-modal/buy-book-modal.component';
import { OfflineModeModalComponent } from './offline-mode-modal/offline-mode-modal.component';
import { FeatureDisabledComponent } from './feature-disabled/feature-disabled.component';
import { MaterialsModalComponent } from './materials-modal/materials-modal.component';
import { AboutThisBookModalComponent } from './about-this-book-modal/about-this-book-modal.component';
import {
    WhiteboardDrawingModalComponent
} from '../../page/book-feature/whiteboard-drawing/whiteboard-drawing-modal/whiteboard-drawing-modal.component';
import { VideoModalComponent } from './video-modal/video-modal.component';
import { WelcomeModalComponent } from './welcome-modal/welcome-modal.component';
import { AlertComponent } from '../../../utils/alert/alert.component';
import { NoInternetModalComponent } from './no-internet-modal/no-internet-modal.component';
import { MyBooksModalComponent } from './my-books-modal/my-books-modal.component';
import { ModalableEdusuite } from '../../../../models/modalable-edusuite';
import { EduSuiteModalComponent } from './edusuite-modal/edu-suite-modal.component';
import { AccessibilityModalComponent } from './accessibility-modal/accessibility-modal.component';
import { ModalableDigbi } from '../../../../models/modalable-digbi';
import { DigbiModalComponent } from './digbi-modal/digbi-modal.component';

@Component({
    selector: 'app-modal-container',
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
    standalone: true,
    imports: [
        HomeworkModalComponent,
        HomeworkExercisePreviewModalComponent,
        AssignmentsLinkModalComponent,
        WhiteboardVideoModalComponent,
        AccessCodeModalComponent,
        LinkModalComponent,
        DigiTrainerModalComponent,
        RedirectModalComponent,
        PlatformLinkCopiedConfirmationModalComponent,
        QuickLinkModalComponent,
        YedoModalComponent,
        OfflineVersionModalComponent,
        ClassSharingModalComponent,
        BuyBookModalComponent,
        OfflineModeModalComponent,
        FeatureDisabledComponent,
        MaterialsModalComponent,
        AboutThisBookModalComponent,
        WhiteboardDrawingModalComponent,
        VideoModalComponent,
        WelcomeModalComponent,
        AlertComponent,
        NoInternetModalComponent,
        MyBooksModalComponent,
        EduSuiteModalComponent,
        AccessibilityModalComponent,
        DigbiModalComponent
    ]
})
export class ModalContainerComponent {

    activeLink: Link;
    activeQuickLink: QuickLink;
    activeHomework: HomeworkLink;
    activeWhiteboard: ModalableWhiteboardDrawing;
    activeWhiteboardVideo: ModalableWhiteboardVideo;
    activeYedoSign: ModalableYedo;
    activeEduSuiteSign: ModalableEdusuite;
    activeDigbi: ModalableDigbi;
    activeAccessCode: ModalableAccessCode;
    materials: Materials;
    activeAssignmentsLink: AssignmentsLink;
    homeworkExercisePreviewModalable: HomeworkExercisePreviewModalable;
    activeVideo: Video;

    subscription: Subscription;

    constructor(public applicationStateService: ApplicationStateService,
                private cdRef: ChangeDetectorRef,
                public modalService: ModalService,
                public offlineModeService: OfflineModeService) {

        this.subscription = this.modalService.openModalObservable.subscribe(modalable => {
            this.resetActiveElements();
            this.updateModal(modalable);
        });
    }

    resetActiveElements(): void {
        this.activeLink = null;
        this.activeQuickLink = null;
        this.activeHomework = null;
        this.activeWhiteboard = null;
        this.activeWhiteboardVideo = null;
        this.activeYedoSign = null;
        this.activeEduSuiteSign = null;
        this.activeDigbi = null;
        this.activeAccessCode = null;
        this.materials = null;
        this.activeVideo = null;
        this.activeAssignmentsLink = null;
        this.homeworkExercisePreviewModalable = null;
        this.cdRef.detectChanges();
    }

    private updateModal(modalable: Modalable): void {

        if (modalable instanceof Link) {
            this.activeLink = modalable;
        }

        if (modalable instanceof QuickLink) {
            this.activeQuickLink = modalable;
        }

        if (modalable instanceof HomeworkLink) {
            this.activeHomework = modalable;
        }

        if (modalable instanceof ModalableWhiteboardDrawing) {
            this.activeWhiteboard = modalable;
        }

        if (modalable instanceof ModalableWhiteboardVideo) {
            this.activeWhiteboardVideo = modalable;
        }

        if (modalable instanceof Video) {
            this.activeVideo = modalable;
        }

        if (modalable instanceof ModalableYedo) {
            this.activeYedoSign = modalable;
        }

        if (modalable instanceof ModalableEdusuite) {
            this.activeEduSuiteSign = modalable;
        }

        if (modalable instanceof ModalableDigbi) {
            this.activeDigbi = modalable;
        }

        if (modalable instanceof ModalableAccessCode) {
            this.activeAccessCode = modalable;
        }

        if (modalable instanceof Materials) {
            this.materials = modalable;
        }

        if (modalable instanceof AssignmentsLink) {
            this.activeAssignmentsLink = modalable;
        }

        if (modalable instanceof HomeworkExercisePreviewModalable) {
            this.homeworkExercisePreviewModalable = modalable;
        }
    }

}
